module.exports = __webpack_public_path__ + "media/images/flags/4x3/cyp-77ed2b380bbac957f31af8ab9b0eb7f8.svg";